import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { dailyLimitReached, logOut, setTokens, userInActive } from "./auth";
import { API_URL } from "../constants";

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  method: "GET",
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    var csrfToken = null;
    var cookieMatch = document.cookie.match(/csrftoken=(.*?)(?:$|;)/);
    if (cookieMatch) {
      csrfToken = cookieMatch[1];
    }
    headers.set("authorization", `Bearer ${token}`);
    headers.set("X-CSRFToken", csrfToken);
    // The following messes up multi-part (file upload) calls
    //headers.set("Content-Type", "application/json");
    return headers;
  },
});

const baseQueryWithReAuth = async (args, api, extraOptions) => {

  var result = await baseQuery(args, api, extraOptions);
  if (result?.error?.data?.code === 'user_inactive') {
    api.dispatch(userInActive(true));
  }
  if (result?.error?.data?.code === 'daily_limit_reached') {
    api.dispatch(dailyLimitReached(true));
  }
  // Backend returns this when the token is 50% expired - this will renew it and retry the request. 
  if (result?.error?.status === 403 || result?.error?.code === 'token_nearing_expiration') {
    // send refresh token
    const refreshResult = await baseQuery(
      {
        url: "api/token/refresh/",
        method: "POST",
        body: { refresh: api.getState().auth.refreshToken },
      },
      api,
      extraOptions
    );
    if (refreshResult?.data?.access) {
      const access = refreshResult?.data?.access;
      api.dispatch(setTokens({ token: access }));
      // retry the initial request
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logOut());
    }
  }
  // Force a logout if we haven't had activity within the backend's access token expiration time
  if (result?.error?.status === 401 || result?.error?.code === 'token_not_valid') {
    api.dispatch(logOut());
  }
  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReAuth,
  tagTypes: [
    'Session', 
    'TrainingDashboard', 
    'TrainingModule', 
    'TrainingProgress', 
    'TrainingAnalytics',
    'ImpactStories',
    'CredentialingDashboard',
    'BadgeProgress',
    'UserBadges',
    'BadgeEligibility',
    'BadgeModule',
    'ModuleCompletionStatus',
    'QuizResults'
  ],
  endpoints: (builder) => ({}),
});
